<div class="pointRemindersList__container" role="region" aria-label="Reminders list">
  @if (reminders.length === 0 && !processing) {
    <p class="pointRemindersList__placeholderText" role="status">
      {{ 'empty_reminder_list' | ppTranslate }}
    </p>
  }
  @if (processing) {
    <div role="status" aria-label="Loading reminders">
      <pp-spinner></pp-spinner>
    </div>
  }
  <ul role="list" aria-label="Reminders" class="pointRemindersList__list">
    @for (reminder of reminders; track reminder) {
      <li class="pointRemindersList__item">
        <pp-point-reminder [ppReminder]="reminder"></pp-point-reminder>
      </li>
    }
  </ul>
</div>
